import { useAnalytics } from '@hotpot-arcade/analytics-client';
import { lazy, Suspense, useEffect } from 'react';

const MafiaMatchPage = lazy(() => import('@hotpot-arcade/mafia-client').then((m) => ({ default: m.MafiaMatchPage })));

/**
 * Entry point for the standalone Mafia Discord activity (VITE_APP_VARIANT=mafia).
 * Boots straight into the Mafia game full-screen with no arcade shell, home, or
 * game picker. The game_opened/closed analytics that GamePage normally emits are
 * lifted here so Mafia sessions still report in this variant.
 */
export function MafiaOnly() {
  const { track } = useAnalytics();

  useEffect(() => {
    track({ name: 'game_opened', props: { game_name: 'mafia' } });
    return () => {
      track({ name: 'game_closed', props: { game_name: 'mafia' } });
    };
  }, [track]);

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-grow w-full h-full">
        <Suspense
          fallback={
            <div className="w-full h-full flex items-center justify-center bg-black text-white/60 text-sm">
              Loading…
            </div>
          }
        >
          <MafiaMatchPage websocketUrl={import.meta.env.VITE_MAFIA_WEBSOCKET} />
        </Suspense>
      </div>
    </div>
  );
}
